import { SVGProps } from 'react';

const ArrowUpNarrowWide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 8 7 4 3 8m4-4v16m4-8h4m-4 4h7m-7 4h10"
    />
  </svg>
);
export default ArrowUpNarrowWide;
